import get from 'lodash/get'
import { useEffect, useState } from 'react'
import { FileField, ImageField } from 'react-admin'
import { fileUrl } from '~/helpers'

/**
 * An attachment as an image (with caption) or a download link.
 *
 * A stored attachment's `source` is an nhost/storage file id, which the
 * browser cannot load on its own — files need a token, and an <img> sends
 * none. It is swapped for a short-lived presigned URL. Anything else (the
 * `blob:` preview of a file not yet uploaded) is used as it is.
 */
export const FileImageField = ({
  record,
  typeSource = 'rawFile.type',
  captionSource = 'caption',
  source,
  ...rest
}) => {
  const value = get(record, source)
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    let current = true
    fileUrl(value)
      .then((resolved) => current && setUrl(resolved ?? value))
      .catch(() => current && setUrl(null))
    return () => {
      current = false
    }
  }, [value])

  if (!url) {
    return null
  }
  const type = get(record, typeSource) ?? ''
  const pRecord = { ...record, [source]: url }
  return type.startsWith('image') ? (
    <figure>
      <ImageField record={pRecord} source={source} {...rest} />
      {pRecord[captionSource] && <figcaption>{pRecord[captionSource]}</figcaption>}
    </figure>
  ) : (
    <FileField record={pRecord} source={source} target='_blank' {...rest} />
  )
}

export default FileImageField
